<template>
  <div>
    <v-dialog :value="value" persistent scrollable max-width="600">
      <v-card class="pa-4">
        <div class="text-xs-right">
          <v-btn fab small flat @click="$emit('input', false)">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div v-if="loading">
          <scale-loader class="my-4" :loading="true" :color="'primary'"></scale-loader>
        </div>
        <div v-else>
          <v-list>
            <v-list-group v-for="(item, k) in data" :key="k" :prepend-icon="item.action" no-action>
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title style="font-weight: bold">{{ k }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <template v-if="data[k].hasOwnProperty('category')">
                <div>
                  <v-list>
                    <v-list-group
                      v-for="(category, catek) in data[k].category"
                      :key="catek"
                      no-action
                    >
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ catek }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                      <v-list-tile
                        @click="sendGroup(group)"
                        v-for="(group, groupk) in data[k].category[catek].group"
                        :key="groupk"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title class="primary--text">{{ group }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list-group>
                  </v-list>
                </div>
              </template>
              <template v-else-if="data[k].hasOwnProperty('group')">
                <v-list-tile
                  @click="sendGroup(group)"
                  v-for="(group, groupk) in data[k].group"
                  :key="groupk"
                >
                  <v-list-tile-content>
                    <v-list-tile-title class="primary--text">{{ group }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list-group>
          </v-list>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: {
    value: {
      default: false
    }
  },
  data() {
    return {
      data: [],
      loading: true
    }
  },
  components: {
    ScaleLoader
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getProducts()
  },
  methods: {
    sendGroup(group) {
      this.$emit('onSendGroup', group)
    },
    getProducts() {
      this.loading = true
      api.getProductToaToLiveChat({ pageid: this.selectedBot.pageid }, (err, response) => {
        this.loading = false
        this.data = response.data[0]
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/ToaProductsDialog.vue